import { styled } from "styled-components";

export const AddressDetailsFormContainer = styled.div`
  .address-details-form {
    border-bottom: 1px solid #e5e7ef;
    margin-top: 20px;
  }
  .form-container {
    display: flex;
    /* align-items: end; */
    @media (max-width: 575.98px) {
      display: unset;
    }
    label {
      font-weight: 600;
      font-size: 14px;
    }
    .gst-verify {
      display: flex;
      align-items: start;
      justify-content: center;
      .gst-verify-btn {
        margin-top: 30px;
        margin-left: 5px;
        color: white;
        background-color: #1184ff;
        border: none;
        padding: 4px;
        border-radius: 3px;
        &:disabled {
          background-color: #91c6ff;
          cursor: not-allowed;
        }
      }
    }
  }
  .country_container {
    /* white-space: nowrap; */
    position: absolute;
    /* width: 7rem; */
    padding: 0 1.6rem 0 0.5rem;
    text-align: center;
    cursor: pointer;
    .img_flag {
      width: 1.34em;
      height: 1em;
    }
  }
  .country_container::after {
    transform: translateY(-50%) rotate(225deg);
  }
  .country_container::after {
    position: absolute;
    content: "";
    right: 0.8rem;
    top: 45%;
    transform: translateY(-50%) rotate(45deg);
    width: 0.3rem;
    height: 0.3rem;
    border-right: 0.12rem solid #111;
    border-bottom: 0.12rem solid #111;
    transition: 0.2s;
  }
  .country_dropdown {
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 1;
  }
  .mobile_no_input {
    border-radius: 16px;
    border: 1px solid #e5e7ef;
    width: 200px;
    height: 30px;
    box-shadow: 0px 1px 2px 0px rgba(5, 32, 58, 0.1);
    padding: 3px 11px 3px 70px;
    background: #fcfcfc;
    font-size: 0.875rem;
    font-weight: 400;
    color: #8f8ba3;
    @media (max-width: 575.98px) {
      width: 100%;
    }
  }
  .mobile_no_input:focus {
    border: 1px solid #00a4e5 !important;
    outline: none;
  }
  .remove-btn {
    display: flex;
    justify-content: end;
    align-items: center;
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      color: red;
      background-color: transparent;
    }
  }

  .add-new-btn {
    color: #00a4e5;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: transparent;
  }
`;
